import { render, staticRenderFns } from "./PurchaseDuoPurchaseBudgetMutations.vue?vue&type=template&id=4405cf70&"
import script from "./PurchaseDuoPurchaseBudgetMutations.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoPurchaseBudgetMutations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports